import { c as _c } from "react/compiler-runtime";
enum AboutEditError {
  HATE_SPEECH = "HATE_SPEECH",
  PERSONAL_INSULTS = "PERSONAL_INSULTS",
  INAPPROPRIATE_LANGUAGE = "INAPPROPRIATE_LANGUAGE",
  DOXXING = "DOXXING",
  UNKNOWN = "UNKNOWN",
}
type OmitUnknown = Exclude<AboutEditError, AboutEditError.UNKNOWN>;
const ERROR_REGEX: { [k in OmitUnknown]: RegExp } = {
  [AboutEditError.HATE_SPEECH]: /hate\s+speech/i,
  [AboutEditError.PERSONAL_INSULTS]: /personal\s+insults/i,
  [AboutEditError.INAPPROPRIATE_LANGUAGE]: /inappropriate\s+language/i,
  [AboutEditError.DOXXING]: /doxxing\s+of\s+another\s+person/i
};
const ERROR_TEXT: { [k in OmitUnknown]: {
  title: string;
  value: string;
} } = {
  [AboutEditError.HATE_SPEECH]: {
    title: "Error: Hate Speech",
    value: "Your About text was not accepted because our automated checks flagged it for potentially containing hate speech.  We want to keep seize a welcoming place!  We'd appreciate it if you adjusted your text."
  },
  [AboutEditError.PERSONAL_INSULTS]: {
    title: "Error: Personal Insults",
    value: "Your About text was not accepted because our automated checks flagged it for potentially containing a personal insult.  We want to keep seize a welcoming place!.   We'd appreciate it if you adjusted your text."
  },
  [AboutEditError.INAPPROPRIATE_LANGUAGE]: {
    title: "Error: Inappropriate Language",
    value: "Your About text was not accepted because our automated checks flagged it for potentially containing inappropriate language that may make others uncomfortable.   We want to keep seize a welcoming place!  We'd appreciate it if you adjusted your text."
  },
  [AboutEditError.DOXXING]: {
    title: "Error: Doxxing of Another Person",
    value: "Your About text was not accepted because our automated checks flagged it for potentially doxxing another user of the system.   We have a strong cultural value towards respecting pseudonymity so we'd appreciate if if you adjusted your text."
  }
};
export default function UserPageHeaderAboutEditError(t0) {
  const $ = _c(19);
  const {
    msg,
    closeError
  } = t0;
  const getAboutErrorType = _temp;
  let t1;
  if ($[0] !== msg) {
    t1 = getAboutErrorType(msg);
    $[0] = msg;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const errorType_0 = t1;
  let t2;
  if ($[2] !== errorType_0 || $[3] !== msg) {
    t2 = errorType_0 === AboutEditError.UNKNOWN ? {
      title: "Unknown Error",
      value: msg
    } : ERROR_TEXT[errorType_0];
    $[2] = errorType_0;
    $[3] = msg;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const errorText = t2;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <svg className="tw-h-6 tw-w-6 tw-text-iron-300 tw-transition tw-duration-300 tw-ease-out group-hover:tw-text-iron-400" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M17 7L7 17M7 7L17 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== closeError) {
    t4 = <div className="tw-absolute tw-right-2 tw-top-2"><button onClick={closeError} type="button" title="Close" aria-label="Close" className="tw-group tw-inline-flex tw-rounded-md tw-border-none tw-bg-transparent focus:tw-outline-none">{t3}</button></div>;
    $[6] = closeError;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <svg className="tw-h-5 tw-w-5 tw-flex-shrink-0 tw-text-red" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.9998 8.99999V13M11.9998 17H12.0098M10.6151 3.89171L2.39019 18.0983C1.93398 18.8863 1.70588 19.2803 1.73959 19.6037C1.769 19.8857 1.91677 20.142 2.14613 20.3088C2.40908 20.5 2.86435 20.5 3.77487 20.5H20.2246C21.1352 20.5 21.5904 20.5 21.8534 20.3088C22.0827 20.142 22.2305 19.8857 22.2599 19.6037C22.2936 19.2803 22.0655 18.8863 21.6093 18.0983L13.3844 3.89171C12.9299 3.10654 12.7026 2.71396 12.4061 2.58211C12.1474 2.4671 11.8521 2.4671 11.5935 2.58211C11.2969 2.71396 11.0696 3.10655 10.6151 3.89171Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== errorText.title) {
    t6 = <h3 className="tw-mb-0 tw-text-sm tw-font-semibold tw-text-red">{errorText.title}</h3>;
    $[9] = errorText.title;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== errorText.value) {
    t7 = <div><p className="tw-mb-0 tw-mt-2 tw-text-justify tw-text-sm tw-font-normal tw-text-iron-300">{errorText.value}</p></div>;
    $[11] = errorText.value;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== t6 || $[14] !== t7) {
    t8 = <div className="tw-flex">{t5}<div className="tw-ml-3 tw-flex tw-flex-col tw-self-center lg:tw-max-w-xl">{t6}{t7}</div></div>;
    $[13] = t6;
    $[14] = t7;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t4 || $[17] !== t8) {
    t9 = <div><div className="tw-relative tw-inline-flex tw-w-full tw-items-center tw-rounded-lg tw-border tw-border-solid tw-border-red/30 tw-bg-red/5 tw-p-4 lg:tw-max-w-xl">{t4}{t8}</div></div>;
    $[16] = t4;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  return t9;
}
function _temp(msg_0) {
  for (const errorType in ERROR_REGEX) {
    if (ERROR_REGEX[errorType as OmitUnknown].test(msg_0)) {
      return errorType as AboutEditError;
    }
  }
  return AboutEditError.UNKNOWN;
}